import { render, staticRenderFns } from "./CustomerServe.vue?vue&type=template&id=25c6e9be&scoped=true"
import script from "./CustomerServe.vue?vue&type=script&lang=js"
export * from "./CustomerServe.vue?vue&type=script&lang=js"
import style0 from "./CustomerServe.vue?vue&type=style&index=0&id=25c6e9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c6e9be",
  null
  
)

export default component.exports